import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ComunicationService } from '../../Services/comunication.service';
import { UserService } from '../../Services/userservice.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  login: UntypedFormGroup;
  public status: string;
  public token;


  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private _snackBar: MatSnackBar,
    private userService: UserService
  ) {
    this.login = this.fb.group({
      usuario: ['', Validators.required],
      password: ['', Validators.required],
      recordarme: ['']
    }),
    this.status = '';



  }
  ngOnInit(): void {

    //localStorage.clear();
    this.recordar();
  }

  recordar(){
    let menuSingoff = localStorage.getItem('menuSingoff');
    let rememberMe = localStorage.getItem('rememberMe');
    let email = localStorage.getItem('emailRemember');

    console.log(rememberMe);
    
    if(rememberMe == '1'){
      if(menuSingoff == '1'){
        console.log(menuSingoff);
        this._snackBar.open('Iniciando sesion, por favor espere', '', {
          duration: 2700,
          horizontalPosition: 'left',
          verticalPosition: 'bottom'
        })

        
        this.userService.recordar(email).subscribe(
          (response:any)=>{
            console.log(response);
            
            localStorage.setItem('token', response.token);
            localStorage.setItem('refreshToken', response?.refreshToken);
            localStorage.setItem('role', JSON.stringify(response?.user?.values));
            localStorage.setItem('email', email);
            localStorage.setItem('usuario', JSON.stringify(response?.user));
            //this.userService.is_super();

            if (rememberMe == null) {
              localStorage.setItem('rememberMe', '0');
            } else {
                localStorage.setItem('rememberMe', '1');
                localStorage.setItem('emailRemember', email);
            }

            localStorage.setItem('menuSingoff', '1');

            this.router.navigate(['ini']);


          },
          (err:any)=>{
            console.log(err);
            
          }

        )
        
      }
    }

    /*if (rememberMe == '1') {

        if (menuSingoff == '1') { 
            this.locked = true
            this._snackBar.open('Iniciando sesion, por favor espere', '', {
                duration: 2700,
                horizontalPosition: 'left',
                verticalPosition: 'bottom'
            })

            const objectForSend = {
                email
            }

            this.userService.loginWithRemember(objectForSend).subscribe(
                res => {
                    console.log("res Login: ", res);
                    if (res.status !== 'error') {
                        this.status = 'success';
                        this.token = res.token;

                        localStorage.setItem('token', this.token);
                        localStorage.setItem('locked', JSON.stringify(false));
                        localStorage.setItem('refreshToken', res.refreshToken);
                        localStorage.setItem('user', JSON.stringify(res.user));
                        localStorage.setItem('role', JSON.stringify(res.user.values[4]));
                        localStorage.setItem('bimoto', JSON.stringify(res.roles.values[4]));
                        localStorage.setItem('crediauto', JSON.stringify(res.roles.values[5]));
                        localStorage.setItem('bivienda', JSON.stringify(res.roles.values[6]));
                        localStorage.setItem('tableBimoto', JSON.stringify(res.roles.values[8]));
                        localStorage.setItem('tableCrediauto', JSON.stringify(res.roles.values[7]));
                        localStorage.setItem('tableBivienda', JSON.stringify(res.roles.values[9]));
                        localStorage.setItem('super', JSON.stringify(res.roles.values[10]));
                        localStorage.setItem('superPortal', JSON.stringify(res.roles.values[13]));
                        localStorage.setItem('admin', JSON.stringify(res.roles.values[11]));
                        localStorage.setItem('user', JSON.stringify(res.roles.values[12]));
                        localStorage.setItem('email', email);

                        if (rememberMe == null) {
                            localStorage.setItem('rememberMe', '0');
                        } else {
                            localStorage.setItem('rememberMe', '1');
                            localStorage.setItem('emailRemember', email);
                        }

                        localStorage.setItem('menuSingoff', '1');

                        this.router.navigate(['dashboard']);
                        //this.router.navigate(['login']);
                    } else {
                        if (res.code == 202) {
                            this._snackBar.open(res.message, '', {
                                duration: 5000,
                                horizontalPosition: 'left',
                                verticalPosition: 'bottom'
                            })
                            this.login.reset();
                            return true;
                        }

                        this.status = 'error'
                        this.error();
                        this.login.reset();
                    }
                },
                err => {
                    console.log(err);
                    this.status = 'error',
                    this.login.reset();

                    if (err.status) {
                        if (err.status == 429) {
                            this._snackBar.open(err.error.message, '', {
                                duration: 5000,
                                horizontalPosition: 'left',
                                verticalPosition: 'bottom'
                            })
                        }

                        if (err.status == 405) {
                            this._snackBar.open(err.error.message, '', {
                                duration: 5000,
                                horizontalPosition: 'left',
                                verticalPosition: 'bottom'
                            })
                        }

                        if (err.status == 404) {
                            this._snackBar.open(err.error.message, '', {
                                duration: 5000,
                                horizontalPosition: 'left',
                                verticalPosition: 'bottom'
                            })
                        }

                        if (err.status == 500) {
                            this.error();
                        }

                        if (err.status == 423) {
                            this._snackBar.open(err.error.message, '', {
                                duration: 5000,
                                horizontalPosition: 'left',
                                verticalPosition: 'bottom'
                            })
                        }

                        if (err.status == 202) {
                            this._snackBar.open(err.error.message, '', {
                                duration: 5000,
                                horizontalPosition: 'left',
                                verticalPosition: 'bottom'
                            })
                        }
                    }
                }
            )
        }
    }*/



  }

  ingresar() {
    const user = this.login.value.usuario;
    const password = this.login.value.password;
    const r = this.login.value.recordarme;


    if(!r){
      localStorage.setItem('rememberMe', '0');
      localStorage.removeItem('emailRemember');
    } else {
      localStorage.setItem('rememberMe', '1');
      localStorage.setItem('emailRemember', user);
    }

    localStorage.setItem('menuSingoff', '1');
    

    let response;
    if (user && password) {  


      this.userService.login(user,password,r).subscribe(
        async (res) => {
          console.log(res);
          
          if (res.status !== 'error') {
            this.status = 'success';
            this.token = res.token;

            if(!this.token){
              return this.router.navigate(['login'])
            }
            response = res;

            try {

              const responseVerify = await this.userService.verifyTokenPromesa({token:this.token})
              console.log(responseVerify);
              

              if(responseVerify?.code == 200){
                

                const responseVerifyUser = await this.userService.verifyUser({email:response?.user?.email, id: response?.user?.id, name: response?.user?.name, token: this.token});

                //console.log(responseVerifyUser);
                localStorage.setItem('valid', responseVerifyUser?.ok);
                
                if(responseVerifyUser?.ok){
                  
                  const response2 = await this.userService.verifyUser({email:response?.user?.email, id: response?.user?.id, name: response?.user?.name, token: this.token});
                  

                  if(response2?.ok){
                    localStorage.setItem('token', this.token);
                    localStorage.setItem('refreshToken', response?.refreshToken);
                    localStorage.setItem('role', JSON.stringify(response?.user?.values));
                    localStorage.setItem('email', user);
                    localStorage.setItem('usuario', JSON.stringify(response?.user));
                    this.userService.is_super();
                    this.router.navigate(['ini']);
                  }

                }else{
                  this.router.navigate([''])
                }
                

              }

              
            } catch (error) {
              console.log(error);
              
            }

            /*this.userService.verifyToken({token:this.token}).subscribe(
              res=>{
                localStorage.setItem('token', this.token);
                localStorage.setItem('refreshToken', response.refreshToken);
                localStorage.setItem('role', JSON.stringify(response.user.values));
                localStorage.setItem('email', user);
                localStorage.setItem('usuario', JSON.stringify(response.user));
                this.userService.is_super();
                this.router.navigate(['ini']);

              },
              err=>{
                this.userService.logout();
                this.router.navigate(['login'])
              }
            )*/

            /*localStorage.setItem('token', this.token);
            localStorage.setItem('refreshToken', res.refreshToken);
            localStorage.setItem('role', JSON.stringify(res.user.values));
            localStorage.setItem('email', user);
            localStorage.setItem('usuario', JSON.stringify(res.user));
            this.userService.is_super();
            this.router.navigate(['ini']);*/

          } else {
            if (res.code == 202) {
              this._snackBar.open(res.message, '', {
                  duration: 5000,
                  horizontalPosition: 'left',
                  verticalPosition: 'bottom'
              })  
              this.login.reset();
              return true;
            }
            this.status = 'error'
            this.error();
            this.login.reset();
          }
        },
        err => {
          //console.log('Este es el error', err.status);
          if (err.status == 429) {
              this._snackBar.open(err.error, '', {
                  duration: 5000,
                  horizontalPosition: 'left',
                  verticalPosition: 'bottom'
              })
              this.status = 'error',
              this.login.reset();
              return
          }
          
          this.status = 'error',
          //console.log(<any>err),
          this.error();
          this.login.reset();
        }
      )
    } else {
      this.error();
      this.login.reset();
    }
  }
  error() {
    this._snackBar.open('Se ha producido un problema al iniciar sesión. Comprueba el correo electrónico y la contraseña o crea una cuenta.', '', {
        duration: 2000,
        horizontalPosition: 'left',
        verticalPosition: 'bottom'
    })
}
}
